export enum UserActionTypeRestoreInstalled {
  CalendarAllRestoreInitiated = 'CalendarAllRestoreInitiated',
  CalendarEventsRestoreInitiated = 'CalendarEventsRestoreInitiated',
  CalendarGroupsRestoreInitiated = 'CalendarGroupsRestoreInitiated',
  CalendarsRestoreInitiated = 'CalendarsRestoreInitiated',
  ContactGroupsRestoreInitiated = 'ContactGroupsRestoreInitiated',
  ContactsAllRestoreInitiated = 'ContactsAllRestoreInitiated',
  ContactsRestoreInitiated = 'ContactsRestoreInitiated',
  DriveItemsRestoreInitiated = 'DriveItemsRestoreInitiated',
  MailAllRestoreInitiated = 'MailAllRestoreInitiated',
  MailFolderRestoreInitiated = 'MailFolderRestoreInitiated',
  MailMessagesRestoreInitiated = 'MailMessagesRestoreInitiated',
  SharedDrivesItemsRestoreInitiated = 'SharedDrivesItemsRestoreInitiated',
  SharePointItemsRestoreInitiated = 'SharePointItemsRestoreInitiated'
}
